module.exports = {"211102002":"胜利街道","211102003":"建设街道","211102004":"红旗街道","211102005":"辽河街道","211102008":"铁东街道","211102009":"双盛街道","211102100":"统一镇","211102101":"陆家镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211102.json
// module id = 530
// module chunks = 0